import { getTotalPrice } from 'utils/book-accommodation-and-activity/totalPrice';

const getWidgetTotalPrice = (widgetForm, productData) => {
  const currency = widgetForm.values.currency;
  const dates = widgetForm.values.dates;
  const participants = widgetForm.values.participants;
  const addOns = widgetForm.values.addOns;
  const mandatoryFees =widgetForm.values.mandatoryFees;
  const activities = widgetForm.values.activities;
  const selectedActivities = activities
    ? activities.filter(item => item.isSelected)
    : [];
  const pricesTypeObj = {
    pricesType: productData.pricesType,
    isAccommodation: !productData.scheduleType
  };

  return getTotalPrice(
    pricesTypeObj,
    dates,
    participants,
    addOns,
    mandatoryFees,
    selectedActivities,
    currency,
    widgetForm.values.dates
  );
};

export { getWidgetTotalPrice };
